import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css'; // <-- Make sure this has your Tailwind directives
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FolderFileProvider } from "./context/FolderFileContext";

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FolderFileProvider>
      <App />
    </FolderFileProvider>
  </React.StrictMode>
);

reportWebVitals();
